export default function () {
  return [
    {
      title: '组织层级',
      [$field]: 'allName',
      colSpan: 16,
      rules: ['']
    },
    {
      type: 'Input',
      title: '所属工会',
      readOnly: true,
      [$field]: 'orgName',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '入会日期',
      [$field]: 'joinPartyDate',
      rules: ['']
    },
    {
      type: 'DatePicker',
      title: '任职时间',
      [$field]: 'approvalBuildingDate',
      rules: ['']
    },
    {
      type: 'Input',
      title: '工会现任职务',
      [$field]: 'partyDuty',
      rules: ['']
    },
    {
      title: '业余爱好及特长',
      [$field]: 'expandFieldbd',
      rules: ['']
    },
    // {
    //   title: '是否会员',
    //   type: 'Select',
    //   [$field]: 'memberOrNot',
    //   rules: [''],
    //   optionList: this.dictMap['BOE72']
    // },
    {
      type: 'RemoteSelect',
      title: '是否会员',
      [$field]: 'memberOrNot',
      props: {
        url: 'api-general/module/portal/user/outGetList',
        map: {
          title: 'title',
          value: 'value'
        },
        params: {
          dictCode: 'BOE72',
          bizLineCode: 'YWX03',
          merge: false
        }
      },
      rules: []
    }
  ]
}